import React from "react";

import { Toaster } from "../shadcn/components/ui/sonner";
import { useTranslation } from "../context/Internationalization";

// The app's notifications. Pages call sonner directly:
// toast.success(t("saved")), toast.error(error.message).
const AppToaster = () => {
  const { t } = useTranslation();
  return (
    <Toaster
      position="top-center"
      closeButton
      duration={4000}
      containerAriaLabel={t("notifications")}
      toastOptions={{
        classNames: {
          toast: "cn-toast",
          // Problems use the destructive colour.
          error: "[&_[data-icon]]:text-destructive",
        },
        closeButtonAriaLabel: t("close"),
      }}
    />
  );
};

export default AppToaster;
